import React from 'react';
import withIcon from '../utilities/withIcon';

const IconSearch = () => {
  return (
    <g>
      <path d="m15.7 14.6392-4.09-4.0892a6.4833 6.4833 0 1 0 -1.06 1.0605l4.0892 4.0895a.75.75 0 0 0 1.0608-1.0608zm-14.1194-8.0938a4.9646 4.9646 0 1 1 4.9648 4.9646 4.9706 4.9706 0 0 1 -4.9648-4.9646z" />
    </g>
  );
};

export default withIcon(IconSearch);
